const operations = ['plus', 'minus', '2x', '5x', '10x', '1/2']
type operations = 'plus' | 'minus' | '2x' | '5x' | '10x' | '1/2'

export default function (stake: string, operation: operations, delta: string) {
  if (typeof stake !== 'string') {
    console.error('stake was not string, it was - ' + stake)
    return true
  }
  if (isNaN(+stake)) {
    console.error('stake converted to number was not number, it was - ' + stake)
    return true
  }
  if (!operations.includes(operation)) {
    console.error(
      'operation was not included in operations, it was - ' + operation,
    )
    return true
  }
  if (typeof delta !== 'string') {
    console.error('delta was not string, it was - ' + delta)
    return true
  }
  if (isNaN(+delta)) {
    console.error('delta converted to number was not number, it was - ' + delta)
    return true
  }
  return false
}
